module.exports = __webpack_public_path__ + "img/MAMO-VIOLA-D.6eb41c72.png";